// extracted by mini-css-extract-plugin
export default {"form_wrapper":"RegistrationForm_form_wrapper__WdUlL","gradient-animation":"RegistrationForm_gradient-animation__sQegf"};